import { AssistanceService } from "@/service/services/Assistance.service";
import { branchOfficeService } from "@/service/services/BranchOffice.service";
import { ChargeService } from "@/service/services/Charge.service";
import { CostCenterService } from "@/service/services/CostCenter.service";
import { Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalBranchOfficeTypeDelete.type";

export const ModalBranchOfficeTypeDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, branchOfficeType, onListTypes, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

    const onDeleted= async()=>{
        setLoading(true);
        await branchOfficeService.deleteTypeBranchOffice(branchOfficeType.id).then((data) => {
            onListTypes && onListTypes();
            closeModal && closeModal();
        })
        setLoading(false);
    }
  
    return (
        <>
        <Modal
        open={open}
        handleClose={closeModal}
        size="xs"
        >
        <ModalHeader
            text="ELIMINAR TIPO DE SUCURSAL"
            className='positionElements'
            onCancel={closeModal}
            clearState={clearState}
        >
        </ModalHeader>

        <ModalBody>
            <Typography variant="subtitle1" className="textColor"> 
            ¿Está seguro de eliminar este tipo de Sucursal?
            </Typography>
        </ModalBody>

        <ModalFooter 
            confirmText="Eliminar"
            cancelText="CANCELAR"
            onCancel={closeModal}
            className="footerRight"
            onConfirm={onDeleted}
            clearState={clearState}
        />
        </Modal>
        </>
    )
}